export default __webpack_public_path__ + "static/media/VideoPreview.2e52cd8f.png";